// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const grimmsnarl_gmax: PokeData = {
  "id": 10222,
  "name": "grimmsnarl-gmax",
  "height": 320,
  "weight": 10000,
  "base_experience": 255,
  "types": [
    PokeType.DARK,
    PokeType.FAIRY
  ],
  "api_moves": [],
  "moves": [
    "night-daze",
    "phantom-force",
    "quash",
    "crunch",
    "moonblast",
    "bite",
    "lash-out",
    "flatter",
    "spirit-break",
    "play-rough",
    "dark-pulse",
    "dazzling-gleam",
    "pursuit"
  ],
  "evolution_chain": {
    "id": 451,
    "item": null,
    "species": [
      {
        "name": "impidimp",
        "order": 859,
        "types": [
          PokeType.DARK,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "morgrem",
        "order": 860,
        "types": [
          PokeType.DARK,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 859,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 32,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "grimmsnarl",
        "order": 861,
        "types": [
          PokeType.DARK,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 860,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 42,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 126,
    "speed": 91,
    "ability_power": 183
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": true,
  "regional_variant": null
} as const;
